import { render, staticRenderFns } from "./BatchStockFlowModal.vue?vue&type=template&id=7a8d9356"
import script from "./BatchStockFlowModal.vue?vue&type=script&lang=js"
export * from "./BatchStockFlowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8d9356')) {
      api.createRecord('7a8d9356', component.options)
    } else {
      api.reload('7a8d9356', component.options)
    }
    module.hot.accept("./BatchStockFlowModal.vue?vue&type=template&id=7a8d9356", function () {
      api.rerender('7a8d9356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/batch-stock/BatchStockFlowModal.vue"
export default component.exports